module.exports = __webpack_public_path__ + "media/dorm_1600.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/dorm_1600.jpg
// module id = 23
// module chunks = 0